import { render, staticRenderFns } from "./ReportTabMoreRestaurants.vue?vue&type=template&id=f3d96d16"
import script from "./ReportTabMoreRestaurants.vue?vue&type=script&lang=js"
export * from "./ReportTabMoreRestaurants.vue?vue&type=script&lang=js"
import style0 from "./ReportTabMoreRestaurants.vue?vue&type=style&index=0&id=f3d96d16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports